<template>
    <v-data-table :headers="headers" :items="dependencies" disable-pagination hide-default-footer sort-by="titel" dense>
        <template #item.link="{ item }">
            <a :href="urlForDependency(item)" target="_blank" :title="$t('open_in_new_tab')">
                <KpIcon icon-cls="link" color="primary" />
            </a>
        </template>
    </v-data-table>
</template>

<script>
import { getRouteParams } from '@/helpers/eventsOpenMode';

export default {
    name: 'EventDependencyList',
    props: {
        dependencies: {
            type: Array,
            required: true,
        },
    },

    computed: {
        headers() {
            return [
                { text: this.$t('titel'), sortable: true, value: 'title' },
                { text: this.$t('address'), sortable: true, value: 'location_address' },
                { text: this.$t('event_organizer'), sortable: true, value: 'event_organizer', width: 200 },
                { text: this.$t('rubrik'), sortable: true, value: 'event_genre_groups', width: 90 },
                { value: 'link', sortable: false, width: 50 },
            ];
        },
    },

    methods: {
        urlForDependency(record) {
            const { name, id } = getRouteParams(record);

            return new URL(
                this.$router.resolve({
                    name,
                    params: { id, backRoute: { route: this.$route } },
                }).href,
                window.location.origin,
            ).href;
        },
    },
};
</script>

<style lang="scss" scoped></style>
